import { Button, HeaderBreadcrumbs } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import { useNavigation } from "@web-src/modules/navigation/hooks/useNavigation";
import { useState } from "react";
import { useInvoiceTypeToLabelDictionary } from "@jugl-web/rest-api/invoices/hooks/useInvoiceTypeToLabelDictionary";
import { PreviewInvoiceDialog } from "@jugl-web/domain-resources/invoices/components/PreviewInvoiceDialog";
import useEntity from "@web-src/modules/entities/hooks/useEntity";
import { useChangeInvoiceType } from "@web-src/modules/invoices/hooks/useChangeInvoiceType";
import { useUpdateInvoice } from "@web-src/modules/invoices/hooks/useUpdateInvoice";
import { ReactComponent as EyeIcon } from "./assets/eye.svg";
import { useInvoicesItemFormPageContext } from "../../context/useInvoicesItemFormPageContext";
import { useInvoicesConfigList } from "../../../InvoicesSettingsPage/pages/InvoicesBusinessInformationPage/hooks/useInvoicesConfigList";

interface InvoicesItemHeaderProps {
  id?: string;
}

export const InvoicesItemHeader = ({ id }: InvoicesItemHeaderProps) => {
  const [isPreviewInvoiceDialogOpen, setIsPreviewInvoiceDialogOpen] =
    useState(false);
  const { type, invoiceItemData, skipNavigationAlert } =
    useInvoicesItemFormPageContext();
  const { entity } = useEntity();
  const { t } = useTranslations();
  const { navigateToPage } = useNavigation();
  const { data: configData } = useInvoicesConfigList();
  const config = configData?.data?.[0];
  const dict = useInvoiceTypeToLabelDictionary();

  const changeInvoiceType = useChangeInvoiceType();
  const updateInvoice = useUpdateInvoice();

  const items = [
    {
      title: t({
        id: "invoices-item-form-page.invoices",
        defaultMessage: "Invoices",
      }),
      onClick: () => navigateToPage("invoices"),
    },
    {
      title: id
        ? `${t({
            id: "common.edit",
            defaultMessage: "Edit",
          })} ${dict[type || "invoice"]}`
        : `${t({
            id: "common.new",
            defaultMessage: "New",
          })} ${dict[type || "invoice"]}`,
    },
  ];

  return (
    <HeaderBreadcrumbs
      items={items}
      rightContent={
        <>
          <Button
            variant="tertiary"
            size="sm"
            iconEnd={<EyeIcon />}
            onClick={() => setIsPreviewInvoiceDialogOpen(true)}
          >
            {t({
              id: "common.preview",
              defaultMessage: "Preview",
            })}{" "}
            {dict[type || "invoice"]}
          </Button>
          <PreviewInvoiceDialog
            entityName={entity?.name || ""}
            globalConfig={config}
            isOpen={isPreviewInvoiceDialogOpen}
            onClose={() => setIsPreviewInvoiceDialogOpen(false)}
            invoiceData={invoiceItemData}
            onActionSuccess={(action) => {
              if (action === "void-invoice") {
                skipNavigationAlert.current = true;
              }
            }}
            actions={{
              changeInvoiceType,
              updateInvoice,
            }}
            onNavigate={(str, params) => {
              if (params?.id) {
                navigateToPage(str, {
                  id: params.id,
                });

                return;
              }

              navigateToPage(str, {
                type: params?.type ?? "invoice",
              });
            }}
            availableActions={["copy-url", "download-pdf", "update"]}
          />
        </>
      }
    />
  );
};
